<cfp-combobox
  [name]="'buildingHeader'"
  [ngModel]="activeAddress"
  (ngModelChange)="addressSelected($event)"
  [options]="addresses | orderBy: 'searchable'"
  [inputClass]="''"
  [labelField]="'addressLines[0]'"
  [filterField]="'searchable'"
  [optionTemplate]="optionTemplate"
  [loadingText]="'navbar.buildings.loading'"
  [noResultText]="'navbar.buildings.notFound'"
  [container]="'body'"
  (searchValueChange)="searchValue = $event"
  (openChange)="loadAddresses($event)"
  [ariaLabel]="'aria.label.searchPortfolioBuildingList' | translate"
/>

<ng-template #optionTemplate let-option="option">
  <cfp-building-address
    [buildingId]="option.buildingId"
    [address]="option.addressLines"
    [name]="option.name"
    [showBuildingName]="showBuildingName()"
    [combineNameAndAddress]="combineNameAndAddress()"
    [size]="'sm'"
  />
</ng-template>
